import {
  REJECT_REASON_LIST_SEARCH, REJECT_REASON_LIST_SEARCH_FAILURE, REJECT_REASON_LIST_SEARCH_SUCCESS, REJECT_REASON_DELETE, REJECT_REASON_DELETE_FAILURE, REJECT_REASON_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    rejectReasons: [],
    rejectReasonListNextPage: null,
    rejectReasonListCurrentPage: null
  },
  getters: {
    rejectReasonList: state => {
      return state.rejectReasons
    },
    rejectReasonListNextPage: state => {
      return state.rejectReasonListNextPage
    },
    rejectReasonListCurrentPage: state => {
      return state.rejectReasonListCurrentPage
    }
  },
  actions: {
    [REJECT_REASON_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/reject_reasons'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REJECT_REASON_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REJECT_REASON_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [REJECT_REASON_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('REJECT_REASON_DELETE:' + params.id)
      var data = params.data
      var url = '/master/reject_reasons/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REJECT_REASON_DELETE_FAILURE, res.data)
          } else {
            commit(REJECT_REASON_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [REJECT_REASON_LIST_SEARCH_FAILURE] (state, params) {
      console.log('REJECT_REASON_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [REJECT_REASON_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('REJECT_REASON_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.rejectReasons = state.rejectReasons.concat(data.data)
        state.rejectReasonListCurrentPage = data.meta['current-page']
      } else {
        state.rejectReasons = data.data
        state.rejectReasonListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.rejectReasonListNextPage = data.links['next']
      } else {
        state.rejectReasonListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [REJECT_REASON_DELETE_FAILURE] (state, data) {
      console.log('REJECT_REASON_DELETE_FAILURE')
    },
    [REJECT_REASON_DELETE_SUCCESS] (state, data) {
      console.log('REJECT_REASON_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rejectreason-list.js